import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import Simulator from './pages/Simulator';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Success from './pages/Success';
import Footer from './components/Footer';
import FloatingCTA from './components/FloatingCTA';
import WhatsAppButton from './components/WhatsAppButton';
import { I18nextProvider } from 'react-i18next';
import i18n from './lib/i18n';

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <Router>
        <div className="min-h-screen bg-warm-50">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/servizi" element={<Services />} />
            <Route path="/chi-siamo" element={<About />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contatti" element={<Contact />} />
            <Route path="/simulatore" element={<Simulator />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/richiesta-inviata" element={<Success />} />
          </Routes>
          <Footer />
          <FloatingCTA />
          <WhatsAppButton />
        </div>
      </Router>
    </I18nextProvider>
  );
}

export default App;